import React, { useContext } from 'react';
import { MODALS } from '../../../constants';
import { Context } from '../../../context/AppContext';
import './styles.css';

const Search = ({
  searchKeyword,
  searchLocation,
  showLocationInput,
  defaultCategoryValue,
}) => {
  const {
    modal: { showModal },
  } = useContext(Context);

  return (
    <div className="Header__search">
      <div className="Header__searchInputs">
        {showLocationInput && (
          <button
            className="Header__searchInputLocation"
            onClick={() =>
              showModal(MODALS.SEARCH_AUTOSUGGEST, {
                inputFocus: 'location',
                keywordPlaceholder: searchKeyword,
                categoryValue: defaultCategoryValue,
              })
            }
          >
            <i className="icon-categorynearme" />
            <span>{searchLocation || 'Where'}</span>
          </button>
        )}
        <button
          className="Header__searchInputKeyword"
          onClick={() =>
            showModal(MODALS.SEARCH_AUTOSUGGEST, {
              inputFocus: 'keyword',
              keywordPlaceholder: searchKeyword,
              categoryValue: defaultCategoryValue,
            })
          }
        >
          <i className="icon-generalsearchlarge" />
          <span>{searchKeyword || 'Search'}</span>
        </button>
      </div>
    </div>
  );
};

export default Search;
